import Institutions from '@/api/institutions/institutions'

const institutions = new Institutions()

const institutionsModule = {
  namespaced: true,
  state: {
    items: [],
    lookups: [],
    item: null,
    total: 0,
    students: [],
    load: false,
    aiConfigurations: null,
    loadAiConfigurations: false,
    aiConfigurationsTypesLookups: [],
    lmsConfigurations: null,
    loadLmsConfigurations: false,
    lmsConfigurationsTypesLookups: [],
    microsoftConfigurations: null,
    loadMicrosoftConfigurations: false,
    institutionUsersList: [],
  },
  getters: {
    items(state) {
      return state.items
    },
    load(state) {
      return state.load
    },
    item(state) {
      return state.item
    },
    total(state) {
      return state.total
    },
    students(state) {
      return state.students
    },
    lookups(state) {
      return state.lookups
    },
    aiConfigurations(state) {
      return state.aiConfigurations
    },
    loadAiConfigurations(state) {
      return state.loadAiConfigurations
    },
    aiConfigurationsTypesLookups(state) {
      return state.aiConfigurationsTypesLookups
    },
    lmsConfigurations(state) {
      return state.lmsConfigurations
    },
    loadLmsConfigurations(state) {
      return state.loadLmsConfigurations
    },
    lmsConfigurationsTypesLookups(state) {
      return state.lmsConfigurationsTypesLookups
    },
    microsoftConfigurations(state) {
      return state.microsoftConfigurations
    },
    loadMicrosoftConfigurations(state) {
      return state.loadMicrosoftConfigurations
    },
    institutionUsersList(state) {
      return state.institutionUsersList
    },
  },

  mutations: {
    SET_LOAD: (state, load) => {
      state.load = load
    },
    SET_ITEMS: (state, institutions) => {
      state.items = institutions
    },
    SET_TOTAL_institutions: (state, total) => {
      state.total = total
    },
    SET_STUDENTS: (state, students) => {
      state.students = students
    },
    SET_ITEM: (state, school) => {
      state.item = school
    },
    SET_LOOKUPS(state, lookups) {
      state.lookups = lookups
    },
    SET_AI_CONFIGURATIONS(state, aiConfigurations) {
      state.aiConfigurations = aiConfigurations
    },
    SET_LOAD_AI_CONFIGURATIONS(state, loadAiConfigurations) {
      state.loadAiConfigurations = loadAiConfigurations
    },
    SET_AI_CONFIGURATIONS_TYPES_LOOKUPS(state, aiConfigurationsTypesLookups) {
      state.aiConfigurationsTypesLookups = aiConfigurationsTypesLookups
    },
    SET_LMS_CONFIGURATIONS(state, lmsConfigurations) {
      state.lmsConfigurations = lmsConfigurations
    },
    SET_LOAD_LMS_CONFIGURATIONS(state, loadLmsConfigurations) {
      state.loadLmsConfigurations = loadLmsConfigurations
    },
    SET_LMS_CONFIGURATIONS_TYPES_LOOKUPS(state, lmsConfigurationsTypesLookups) {
      state.lmsConfigurationsTypesLookups = lmsConfigurationsTypesLookups
    },
    SET_MICROSOFT_CONFIGURATIONS(state, microsoftConfigurations) {
      state.microsoftConfigurations = microsoftConfigurations
    },
    SET_LOAD_MICROSOFT_CONFIGURATIONS(state, loadMicrosoftConfigurations) {
      state.loadMicrosoftConfigurations = loadMicrosoftConfigurations
    },
    SET_INSTITUTION_USERS_LIST(state, data) {
      state.institutionUsersList = data
    },
    UPDATE_ITEM_FIELD(state, { field, value }) {
      if (state.item) {
        state.item = { ...state.item, [field]: value }
      }
    },
    UPDATE_INSTITUTION_STATUS(state, { id, status }) {
      if (state.items && state.items.data) {
        const institution = state.items.data.find(item => item.id === id)
        if (institution) {
          institution.status = status
        }
      }
    },
  },

  actions: {
    list({ commit }, query) {
      return new Promise((resolve, reject) => {
        institutions.list(query).then(response => {
          commit('SET_ITEMS', response)
          // commit("SET_TOTAL_institutions", response.institutions.total);
          resolve(response)
        })
      })
    },
    put({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .put(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    store({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .store(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    update({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .update(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    get({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        commit('SET_ITEM', null)
        institutions
          .get(id)
          .then(response => {
            commit('SET_ITEM', response.institution)
            commit('SET_LOAD', false)

            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    remove({ commit }, id) {
      return new Promise((resolve, reject) => {
        institutions
          .remove(id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    students({ commit, dispatch }, institution_id) {
      return new Promise((resolve, reject) => {
        commit('SET_STUDENTS', null)
        institutions
          .students(institution_id)
          .then(response => {
            commit('SET_STUDENTS', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    institutionUsers({ commit }, { institution_id, query }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD', true)
        institutions
          .institutionUsers(institution_id, query)
          .then(response => {
            commit('SET_INSTITUTION_USERS_LIST', response)
            commit('SET_LOAD', false)
            resolve(response)
          })
          .catch(error => {
            commit('SET_LOAD', false)
            reject(error)
          })
      })
    },
    experimentSessionsChart({ commit }, institution_id) {
      return new Promise((resolve, reject) => {
        institutions
          .experimentSessionsChart(institution_id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    institutionLookups({ commit }) {
      return new Promise((resolve, reject) => {
        institutions
          .lookups()
          .then(response => {
            // API may return a plain array or { data: [...] } / { institutions: [...] }
            const list = Array.isArray(response)
              ? response
              : response.data || response.institutions || []
            commit('SET_LOOKUPS', list)
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    aiConfigurations({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_AI_CONFIGURATIONS', null)
        commit('SET_LOAD_AI_CONFIGURATIONS', true)
        institutions
          .aiConfigurations(id)
          .then(response => {
            commit('SET_AI_CONFIGURATIONS', response.data)
            commit('SET_LOAD_AI_CONFIGURATIONS', false)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    aiConfigurationsTypesLookups({ commit }) {
      return new Promise((resolve, reject) => {
        institutions
          .aiConfigurationsTypesLookups()
          .then(response => {
            commit('SET_AI_CONFIGURATIONS_TYPES_LOOKUPS', response.types)
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    storeAiConfigurations({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .storeAiConfigurations(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateCustomAIConfig({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .updateCustomAIConfig(payload.query, payload.id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateAiConfigurations({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .updateAiConfigurations(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    lmsConfigurations({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_LMS_CONFIGURATIONS', null)
        commit('SET_LOAD_LMS_CONFIGURATIONS', true)
        institutions
          .lmsConfigurations(id)
          .then(response => {
            commit('SET_LMS_CONFIGURATIONS', response.data)
            commit('SET_LOAD_LMS_CONFIGURATIONS', false)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    lmsConfigurationsTypesLookups({ commit }) {
      return new Promise((resolve, reject) => {
        institutions
          .lmsConfigurationsTypesLookups()
          .then(response => {
            commit('SET_LMS_CONFIGURATIONS_TYPES_LOOKUPS', response.types)
            resolve(response)
          })
          .catch(e => {
            reject(e)
          })
      })
    },
    storeLmsConfigurations({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .storeLmsConfigurations(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateLmsConfigurations({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .updateLmsConfigurations(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateLmsEnabled({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .updateLmsEnabled(payload.query, payload.id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    getMicrosoftConfigurations({ commit, dispatch }, id) {
      return new Promise((resolve, reject) => {
        commit('SET_MICROSOFT_CONFIGURATIONS', null)
        commit('SET_LOAD_MICROSOFT_CONFIGURATIONS', true)
        institutions
          .getMicrosoftConfigurations(id)
          .then(response => {
            commit('SET_MICROSOFT_CONFIGURATIONS', response.data)
            commit('SET_LOAD_MICROSOFT_CONFIGURATIONS', false)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    storeMicrosoftConfigurations({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .storeMicrosoftConfigurations(payload)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateMicrosoftConfigurations({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .updateMicrosoftConfigurations(payload.query, payload.id)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    updateMicrosoftEnabled({ commit }, payload) {
      return new Promise((resolve, reject) => {
        institutions
          .updateMicrosoftEnabled(payload.query, payload.id)
          .then(response => {
            // Update local state immediately
            commit('UPDATE_ITEM_FIELD', {
              field: 'microsoft_enabled',
              value: payload.query.microsoft_enabled,
            })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    activate({ commit }, id) {
      return new Promise((resolve, reject) => {
        institutions
          .activate(id)
          .then(response => {
            // Update local state immediately
            commit('UPDATE_INSTITUTION_STATUS', {
              id,
              status: true,
            })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    deactivate({ commit }, id) {
      return new Promise((resolve, reject) => {
        institutions
          .deactivate(id)
          .then(response => {
            // Update local state immediately
            commit('UPDATE_INSTITUTION_STATUS', {
              id,
              status: false,
            })
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}

export default institutionsModule
